import VueFeedback from '@ui-common/vue-feedback';

export default {
	components: {
		VueFeedback
	}
};
